(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-contact-locator]';

  function parseCoordinates(raw) {
    if (!raw) return null;
    var parts = raw.split(',').map(function (part) {
      return part.trim();
    });

    if (parts.length < 2) return null;

    var lat = Number(parts[0]);
    var lng = Number(parts[1]);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return { lat: lat, lng: lng };
  }

  function getMarkerIcon(iconUrl) {
    return window.L.icon({
      iconUrl: iconUrl,
      iconSize: [22, 22],
      iconAnchor: [11, 20],
      popupAnchor: [0, -18],
      className: 'contact-map-marker-icon'
    });
  }

  function hideLoader(loader) {
    if (!loader) return;
    loader.classList.add('is-hidden');
  }

  function showMapUnavailable(section) {
    if (!section) return;

    var loader = section.querySelector('[data-map-loader]');
    if (!loader) return;

    loader.classList.remove('is-hidden');
    loader.classList.add('is-error');
    loader.innerHTML = '<span>Map is temporarily unavailable</span>';
  }

  function normalizeText(value) {
    if (!value) return '';
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function createDebounced(fn, delay) {
    var timer = null;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function updateClearButton(state) {
    if (!state.clearButton) return;
    var hasQuery = !!(state.searchQuery && state.searchQuery.length);
    var hasActive = !!state.activeId;
    state.clearButton.hidden = !(hasQuery || hasActive);
  }

  function setActiveStore(state, storeId, shouldZoom) {
    state.activeId = storeId || null;

    state.stores.forEach(function (store) {
      var isActive = store.id === storeId;
      store.element.classList.toggle('is-active', isActive);
      store.marker.setZIndexOffset(isActive ? 1000 : 0);
    });

    updateClearButton(state);

    if (!storeId || !shouldZoom) return;

    var selected = state.stores.find(function (store) {
      return store.id === storeId;
    });

    if (!selected) return;

    state.map.flyTo([selected.coordinates.lat, selected.coordinates.lng], 18, {
      animate: true,
      duration: 0.45
    });
  }

  function fitAllStores(state) {
    if (!state.stores.length) return;

    var points = state.stores.map(function (store) {
      return [store.coordinates.lat, store.coordinates.lng];
    });

    var bounds = window.L.latLngBounds(points);
    state.map.fitBounds(bounds, {
      padding: [28, 28]
    });
  }

  function fitStoresSubset(state, stores) {
    if (!stores || !stores.length) {
      fitAllStores(state);
      return;
    }

    if (stores.length === 1) {
      var single = stores[0];
      state.map.flyTo([single.coordinates.lat, single.coordinates.lng], 14, {
        animate: true,
        duration: 0.45
      });
      return;
    }

    var points = stores.map(function (store) {
      return [store.coordinates.lat, store.coordinates.lng];
    });

    var bounds = window.L.latLngBounds(points);
    state.map.fitBounds(bounds, {
      padding: [8, 8],
      maxZoom: 14
    });
  }

  function findStoresByQuery(state, query) {
    var normalizedQuery = normalizeText(query);
    if (!normalizedQuery) return state.stores;

    var tokens = normalizedQuery.split(' ').filter(Boolean);
    if (!tokens.length) return state.stores;

    return state.stores.filter(function (store) {
      return tokens.every(function (token) {
        return store.searchText.indexOf(token) !== -1;
      });
    });
  }

  function initSection(section) {
    if (section.dataset.locatorReady === 'true') return;
    if (!window.L) {
      showMapUnavailable(section);
      return;
    }

    var mapElement = section.querySelector('[data-contact-map]');
    var loader = section.querySelector('[data-map-loader]');
    var clearButton = section.querySelector('[data-store-clear]');
    var searchInput = section.querySelector('.contact-page__store-input');
    var storeElements = Array.prototype.slice.call(section.querySelectorAll('.contact-page__store[data-coordinates]'));
    var iconSource = section.querySelector('.contact-page__store-pin');

    if (!mapElement || !storeElements.length || !iconSource) {
      hideLoader(loader);
      return;
    }

    var map = window.L.map(mapElement, {
      zoomControl: true,
      scrollWheelZoom: false
    });

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap'
    }).addTo(map);

    var markerIcon = getMarkerIcon(iconSource.src);
    var stores = [];

    storeElements.forEach(function (element) {
      var coords = parseCoordinates(element.dataset.coordinates);
      if (!coords) return;

      var marker = window.L.marker([coords.lat, coords.lng], {
        icon: markerIcon
      }).addTo(map);

      var id = element.dataset.storeId || '';
      stores.push({
        id: id,
        element: element,
        marker: marker,
        coordinates: coords,
        searchText: normalizeText(element.textContent || '')
      });
    });

    var state = {
      map: map,
      stores: stores,
      activeId: null,
      clearButton: clearButton,
      searchInput: searchInput,
      searchQuery: ''
    };

    if (!stores.length) {
      hideLoader(loader);
      return;
    }

    stores.forEach(function (store) {
      store.marker.on('click', function () {
        setActiveStore(state, store.id, true);
        store.element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      });

      store.element.addEventListener('click', function () {
        setActiveStore(state, store.id, true);
      });
    });

    if (searchInput) {
      var onSearch = createDebounced(function (rawValue) {
        state.searchQuery = normalizeText(rawValue);
        setActiveStore(state, null, false);

        if (!state.searchQuery) {
          fitAllStores(state);
          return;
        }

        var matchedStores = findStoresByQuery(state, state.searchQuery);
        fitStoresSubset(state, matchedStores);
      }, 420);

      searchInput.addEventListener('input', function () {
        onSearch(searchInput.value || '');
      });
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        if (state.searchInput) {
          state.searchInput.value = '';
          state.searchQuery = '';
        }
        setActiveStore(state, null, false);
        fitAllStores(state);
      });
    }

    // Set the initial viewport immediately.
    // Using whenReady here would deadlock because readiness depends on having a view.
    fitAllStores(state);
    hideLoader(loader);
    updateClearButton(state);
    setTimeout(function () {
      map.invalidateSize();
    }, 150);

    section.dataset.locatorReady = 'true';
  }

  function initAllSections() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  function showUnavailableForAllSections() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(function (section) {
      if (section.dataset.locatorReady === 'true') return;
      showMapUnavailable(section);
    });
  }

  function waitForLeafletAndInit(attempt) {
    if (window.L) {
      initAllSections();
      return;
    }

    if (attempt > 120) {
      showUnavailableForAllSections();
      return;
    }

    setTimeout(function () {
      waitForLeafletAndInit(attempt + 1);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForLeafletAndInit(0);
    });
  } else {
    waitForLeafletAndInit(0);
  }

  window.addEventListener('load', function () {
    waitForLeafletAndInit(0);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = null;
    if (event.target && event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      section = event.target;
    } else if (event.target) {
      section = event.target.querySelector(SECTION_SELECTOR);
    }
    if (!section) return;
    waitForLeafletAndInit(0);
  });
})();
